import React from "react";
import { Select } from "antd";
import { FilterOutlined } from "@ant-design/icons";
import { canUseSubscriptionFeatures } from "../../../../shared/billing";
import './SelectJobModal.css'
import TalentResultBackIcon from '../../../../assets/icons/talent-result-back.svg'

function formatCount(count) {
  if (count >= 1000000) {
    return `${parseFloat((count / 1000000).toFixed(1))}M`;
  }

  return count.toLocaleString();
}

const QueryPageHeader = ({
  totalMatches,
  searchTerm,
  filterCount = 0,
  onOpenFilter,
  showSelectAll = false,
  allSelected = false,
  onToggleSelectAll,
  iconEmoji,
  iconClass,
  titleText,
  onBack,
  sortOrder = "relevant",
  onChangeSortOrder,
  showMostRelevantSort = false,
  showActions = true,
}) => {
  const showExternalProfileCopy = canUseSubscriptionFeatures();
  const sortOptions = [
    ...(showMostRelevantSort
      ? [{ value: "relevant", label: "Most Relevant" }]
      : []),
    { value: "last_active", label: "Last Active" },
    { value: "new_skill_listing", label: "New Skill Listing" },
  ];
  const selectedSortOrder = sortOptions.some((option) => option.value === sortOrder)
    ? sortOrder
    : sortOptions[0]?.value;

  return (
    <>
    {onBack && (
      <div className="qp-back-row">
        <button
          className="qp-back-btn"
          type="button"
          onClick={onBack}
          aria-label="Go back"
        >
          <img src={TalentResultBackIcon} alt="" />
        </button>
      </div>
    )}

    <div className="qp-header">
      <div className="qp-header-left">
      {titleText && (
        <div className={`qp-section-icon ${iconClass}`}>
          {iconEmoji}
        </div>
      )}

      <div className={titleText ? "qp-header-copy qp-header-copy-with-icon" : "qp-header-copy"}>
        {titleText ? (
          <span className="qp-header-title">
            {titleText}
          </span>
        ) : (
          <h2>{formatCount(totalMatches)} Matches Found</h2>
        )}

        {showExternalProfileCopy && searchTerm && (
          <p>
            We searched across <strong className="qp-header-highlight">850M+ professional profiles</strong> to find relevant talent for &ldquo;
            {searchTerm}
            &rdquo;.
          </p>
        )}
      </div>
    </div>
    {showActions && <div className="qp-header-right">
      {showSelectAll && (
        <label className="qp-select-all">
          <input
            type="checkbox"
            checked={allSelected}
            onChange={onToggleSelectAll}
            aria-label="Select all visible talent cards"
          />
          <span>Select All</span>
        </label>
      )}
      {onOpenFilter && (
        <button className="qp-filter-btn" type="button" onClick={onOpenFilter}>
          <FilterOutlined />
          Filters&nbsp;
        {filterCount > 0 && (
  <span className="qp-filter-badge">{filterCount}</span>
)}
        </button>
      )}
      {onChangeSortOrder && (
        <Select
          className="qp-sort-select"
          value={selectedSortOrder}
          onChange={onChangeSortOrder}
          style={{ width: 156 }}
          options={sortOptions}
        />
      )}
    </div>}
  </div>
  </>
  );
};

export default QueryPageHeader;

